import logo from "../../../assets/images/logo.png";
import React, { useState, useMemo, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const OTPVerification = () => {
  const navigate = useNavigate();

  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [otpValues, setOtpValues] = useState(Array(6).fill(""));
  const otpLength = 6;
  const otpRefs = useRef([]);

  const [otpSent, setOtpSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [verifying, setVerifying] = useState(false);

  const [resendTimer, setResendTimer] = useState(0);

  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setInterval(() => setResendTimer(prev => prev - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [resendTimer]);

  const handleSendOTP = async () => {
    if (whatsappNumber.length !== 10) {
      alert("Enter a valid 10-digit WhatsApp number.");
      return;
    }

    try {
      setSending(true);

      // sendOTP API call ---
      // const response = await sendOTP(...)

      setOtpSent(true);
      setOtpValues(Array(otpLength).fill(""));
      setResendTimer(60);
      alert("OTP sent!");
    } catch (error) {
      alert("Failed to send OTP.");
    } finally {
      setSending(false);
    }
  };

  const handleOtpChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otpValues];
    newOtp[index] = value;
    setOtpValues(newOtp);

    if (value && index < otpLength - 1) {
      otpRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otpValues[index] && index > 0) {
      otpRefs.current[index - 1].focus();
    }
  };

  const handleVerifyOTP = async () => {
    const otp = otpValues.join("");

    if (otp.length !== otpLength) {
      alert(`Please enter ${otpLength}-digit OTP.`);
      return;
    }

    try {
      setVerifying(true);

      // verifyOTP API call ---
      // const response = await verifyOTP(...)

      alert("OTP verified!");
    } catch (error) {
      alert("OTP verification failed.");
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: "500px" }}>

      {/* Logo */}
      <div className="text-center mb-4">
        <img src={logo} alt="Logo" style={{ width: "200px" }} />
      </div>

      <h4 className="text-center">WhatsApp OTP Verification</h4>

      {/* STEP 1 → Enter Phone Number */}
      {!otpSent && (
        <>
          <input
            className="form-control mb-3"
            type="text"
            placeholder="Enter WhatsApp Number"
            value={whatsappNumber}
            onChange={(e) => setWhatsappNumber(e.target.value)}
            maxLength={10}
          />

          <button
            className="btn btn-primary mb-3 w-100"
            onClick={handleSendOTP}
            disabled={sending}
          >
            {sending ? "Sending OTP..." : "Send OTP"}
          </button>
        </>
      )}

      {/* STEP 2 → OTP Boxes (appear only after clicking Send OTP) */}
      {otpSent && (
        <>
          <div className="text-center mb-3">
            <strong>OTP sent to: {whatsappNumber}</strong>
          </div>

          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "center",
              marginBottom: "15px",
            }}
          >
            {otpValues.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (otpRefs.current[index] = el)}
                type="text"
                maxLength="1"
                value={digit}
                onChange={(e) => handleOtpChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                style={{
                  width: "50px",
                  height: "50px",
                  textAlign: "center",
                  fontSize: "22px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                }}
              />
            ))}
          </div>

          <button
            className="btn btn-success w-100"
            onClick={handleVerifyOTP}
            disabled={verifying}
          >
            {verifying ? "Verifying..." : "Verify & Continue"}
          </button>

          <button
            className="btn btn-link w-100 mt-2"
            onClick={handleSendOTP}
            disabled={resendTimer > 0}
          >
            {resendTimer > 0
              ? `Resend OTP in ${resendTimer}s`
              : "Resend OTP"}
          </button>
        </>
      )}
    </div>
  );
};

export default OTPVerification;
